"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.evaluationRules = exports.databaseRules = exports.clientRules = exports.rules = exports.serverRules = void 0;
const clientRules_1 = require("./clientRules");
Object.defineProperty(exports, "clientRules", { enumerable: true, get: function () { return clientRules_1.clientRules; } });
const databaseRules_1 = require("./databaseRules");
Object.defineProperty(exports, "databaseRules", { enumerable: true, get: function () { return databaseRules_1.databaseRules; } });
const evaluationRules_1 = require("./evaluationRules");
Object.defineProperty(exports, "evaluationRules", { enumerable: true, get: function () { return evaluationRules_1.evaluationRules; } });
const asynchronousRules_1 = require("./asynchronousRules");
// GOTCHA(G-CORE05)
exports.serverRules = [...asynchronousRules_1.asynchronousRules, ...databaseRules_1.databaseRules];
exports.rules = [...clientRules_1.clientRules, ...evaluationRules_1.evaluationRules];
